<section id="st-product-sets">
    <div class="container">
        <div class="heading">
            <h2 class="h-large">특별 컬렉션</h2>
            <span class="block">독특한 풍미와 프리미엄 품질의</span><span class="block"> 특별한 컬렉션을 만나보세요.</span>
        </div>
        
        <div class="featured-slider slider-ref" id="xxx-slider" data-display="3,3,2,2" data-dot="on" data-nav="off" data-under="991">
            <div class="slider-content">
                <div class="slider-wrapper row">
                    <ng-container *ngFor="let item of contentsPdtCates;">
                        <div class="col-lg-4 slide set">
                            <a href="javascript:;" (click)="goToShoppingMall(item);">
                                <div class="img-wrapper">
                                    <ng-container *ngIf="item.fileName">
                                        <img [src]="urlWownet + '/' + item.filePath + item.fileName">
                                    </ng-container>
                                    <ng-container *ngIf="!item.fileName">
                                        <img src="/assets/img/noImage.jpg">
                                    </ng-container>
                                </div>
                                <div class="w-btn medium-btn hover-icon-btn">
                                    <span class="h-small">{{ item.cateName }} </span>
                                    <div class="hover-icon">
                                        <img src="/assets/img/icons/arrow-right-green.svg">
                                    </div>
                                </div>
                            </a>
                        </div>
                    </ng-container>                
                </div>
            </div>
            				
        </div>
    </div>
    

</section>